import { render } from "./DepositOtherPlatformNft.vue?vue&type=template&id=0bf0a98e&scoped=true"
import script from "./DepositOtherPlatformNft.vue?vue&type=script&lang=js"
export * from "./DepositOtherPlatformNft.vue?vue&type=script&lang=js"

import "@/Common/Styles/chooseToDepositNft.scss?vue&type=style&index=0&id=0bf0a98e&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/THEOS-interfaces/THEOS-interfaces/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf0a98e"]])

export default __exports__